/**
 * The object of the Bold command.
 */
const bold = {
    mark: 'strong',
    altMarks: ['b'],
    altStyle: { name: 'font-weight', value: /^(bold(er)?|[5-9]\d{2,})$/ }
};
/**
 * The object of the Italic command.
 */
const italic = {
    mark: 'em',
    altMarks: ['i'],
    altStyle: { name: 'font-style', value: /^italic$/i }
};
/**
 * The object of the Underline command.
 */
const underline = {
    mark: 'u',
    altStyle: { name: 'text-decoration', value: /^underline$/i }
};
/**
 * The object of the Strikethrough command.
 */
const strikethrough = {
    mark: 'del',
    altStyle: { name: 'text-decoration', value: /^line-through$/i }
};
/**
 * The object of the Subscript command.
 */
const subscript = {
    mark: 'sub'
};
/**
 * The object of the Superscript command.
 */
const superscript = {
    mark: 'sup'
};
/**
 * The object of the Link tool settings.
 */
const link = {
    mark: 'link'
};

export { bold, italic, link, strikethrough, subscript, superscript, underline };
